import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack, type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { Button } from "@src/appV2/redesign/components/Button";

export interface PayoutScheduleItemDisabledSectionProps {
  disabledMessage?: string;
  disabledCTA?: string;
  onDisabledCTAClick?: () => void;
  sx?: SxProps<Theme>;
}

export function PayoutScheduleItemDisabledSection(props: PayoutScheduleItemDisabledSectionProps) {
  const { disabledMessage, disabledCTA, onDisabledCTAClick, sx } = props;

  return (
    <Stack sx={sx}>
      <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
        <CbhIcon
          type="triangle-exclamation"
          color={(theme) => theme.palette.intent?.warning.backgroundInvert}
          size="small"
        />
        <Text
          variant="caption"
          sx={(theme) => ({
            color: theme.palette.intent?.warning.backgroundInvert,
            fontWeight: 500,
            ml: theme.spacing(3),
          })}
        >
          {disabledMessage}
        </Text>
      </Stack>
      {disabledCTA ? (
        <Button
          data-testid="payout-schedule-item-disabled-cta-button"
          variant="outlined"
          size="small"
          sx={(theme) => ({ mt: theme.spacing(3) })}
          onClick={onDisabledCTAClick}
        >
          {disabledCTA}
        </Button>
      ) : null}
    </Stack>
  );
}
